
import state from './moduleFranchiseState.js';
import mutations from './moduleFranchiseMutations.js';
import actions from './moduleFranchiseActions.js';
import getters from './moduleFranchiseGetters.js';

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
